import e from "./ghl-ui.es742.js";
const n = {
  name: "en-US",
  locale: e
}, a = n;
export {
  a as default
};
